export const PERFIS = ['UBS', 'REGULACAO', 'GESTOR', 'ADMINISTRADOR'] as const;

export type PerfilUsuario = (typeof PERFIS)[number];

export const ROTULOS_PERFIL: Record<PerfilUsuario, string> = {
  UBS: 'UBS',
  REGULACAO: 'Regulação',
  GESTOR: 'Gestor',
  ADMINISTRADOR: 'Administrador',
};

export interface UsuarioAutenticado {
  id: string;
  nome: string;
  email: string;
  perfil: PerfilUsuario;
  ubsId: string | null;
  precisaTrocarSenha?: boolean;
}

export interface RespostaLogin {
  accessToken: string;
  expiraEmSegundos: number;
  usuario: UsuarioAutenticado & { precisaTrocarSenha: boolean };
}
